export default __webpack_public_path__ + "static/media/Easybank.068fc338.png";